module.exports = __webpack_public_path__ + "img/recharge-t-mobile.7dad05ac.png";